import { supabase } from "@/lib/supabase";
import { downloadCsv, type CsvColumn } from "@/lib/csv";
import { editionLabel, LICENSE_STATUS_META } from "@/lib/license";

interface ReportRow {
  license_key: string;
  product_name: string;
  edition: string;
  status: string;
  seat_count: number;
  activation_count: number;
  max_activations: number;
  issued_at: string | null;
  expires_at: string | null;
}

interface ExportResponse {
  rows: ReportRow[];
}

const columns: CsvColumn<ReportRow>[] = [
  { key: "license_key", label: "许可证密钥", value: (row) => row.license_key },
  { key: "product_name", label: "产品名称", value: (row) => row.product_name },
  { key: "edition", label: "版本类型", value: (row) => editionLabel(row.edition) },
  { key: "status", label: "状态", value: (row) => LICENSE_STATUS_META[row.status]?.label ?? row.status },
  { key: "seat_count", label: "授权席位", value: (row) => row.seat_count },
  { key: "activation_count", label: "已激活", value: (row) => row.activation_count },
  { key: "max_activations", label: "最大激活数", value: (row) => row.max_activations },
  { key: "issued_at", label: "签发时间", value: (row) => row.issued_at ?? "" },
  { key: "expires_at", label: "到期时间", value: (row) => row.expires_at ?? "" },
];

export async function exportLicenseReport(): Promise<number> {
  const { data, error } = await supabase.functions.invoke("export-license-report", { body: {} });
  if (error) throw error;

  const rows = (data as ExportResponse | null)?.rows ?? [];
  const stamp = new Date().toISOString().slice(0, 10);
  downloadCsv(`授权报表_${stamp}.csv`, columns, rows);
  return rows.length;
}